'use client';
import { ReactNode } from 'react';

import Link from 'next/link';
import { useTranslations } from 'next-intl';

import RoundedBox from 'ui/RoundedBox';

const SubriteNotFound = ({
  sectionName,
  sectionURL,
}: {
  sectionName?:
    | 'm2mClient'
    | 'mypage'
    | 'newsletter'
    | 'subriteid'
    | 'webhook'
    | 'user'
    | 'account_settings'
    | 'automation'
    | 'landingPages'
    | 'member'
    | 'productPackage'
    | 'product'
    | 'subscriptionPlan'
    | 'podcast'
    | 'segmentation'
    | 'customProperty'
    | 'paymentMethod';
  sectionURL?: string;
}) => {
  const t = useTranslations('subriteNotFound');

  return (
    <div className="flex flex-col items-center justify-center flex-1">
      <div className="max-w-md">
        <RoundedBox>
          <h1 className="max-w-md text-xl font-bold text-center md:text-2xl">
            {t('notFoundText', { translatedSectionName: t(sectionName || 'global') })}
          </h1>
          <p className="max-w-md mt-4 text-center">
            {t.rich('redirectText', {
              translatedSectionName: t(
                sectionName ? `${sectionName}ListRedirectText` : 'globalRedirectText',
              ),
              link: (chunks: ReactNode) => (
                <Link className="underline" href={sectionURL || '/'}>
                  {chunks}
                </Link>
              ),
            })}
          </p>
        </RoundedBox>
      </div>
    </div>
  );
};

export default SubriteNotFound;
